

import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Backdrop
} from "@mui/material";
import { styled } from "@mui/system";
import { useLocation, useParams } from "react-router-dom";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";

import COCmodal from "../modals/COCmodal.jsx";
import SignOnModal from "../modals/SignOnModal.jsx";
import SignOffModal from "../modals/SignOffModal.jsx";
import DepartureModal from "../modals/DepartureModal.jsx";

const CircleButton = styled(Button)(({ theme }) => ({
  width: 100,
  height: 100,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "none",
  fontSize: "1rem",
  fontWeight: "bold",
  boxShadow: theme.shadows[3],
  transition: "0.3s",
  "&:hover": {
    boxShadow: theme.shadows[6],
  },
}));

const Signinsignoffcrewingagent = () => {
  const [cocDetails, setCocDetails] = useState([]);
  const [signonDetails, setSignonDetails] = useState([]);
  const [signoffDetails, setSignoffDetails] = useState([]);
  const [departureDetails, setDepartureDetails] = useState([]);
  const [activeModal, setActiveModal] = useState(null);
  const [loading, setLoading] = useState(false); // ⬅️ Loading state added

  const location = useLocation();
  const { id: crewingAgentId } = useParams();

  useEffect(() => {
    if (location.state?.openFormI) {
      handleCOCClick();
    }
  }, [location.state]);

  const fetchStatusByType = async (type, setData, modalKey) => {
    setLoading(true); // Start loading
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(
        `${baseURL}/api/crewingAgent/getStatusAfterForm1ByCrewingAgentId/${crewingAgentId}/${type}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setData(response.data.data || []);
      setActiveModal(modalKey);
    } catch (error) {
      console.error(`Error fetching ${type} data:`, error.response?.data || error.message);
      setData([]);
      setActiveModal(modalKey);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const handleCOCClick = () => fetchStatusByType("coc", setCocDetails, "coc");
  const handleSignOnClick = () => fetchStatusByType("signOn", setSignonDetails, "signOn");
  const handleSignOffClick = () => fetchStatusByType("signOff", setSignoffDetails, "signOff");
  const handleDepartureClick = () => fetchStatusByType("departure", setDepartureDetails, "departure");

  return (
    <>
      {/* <Navbar /> */}
      <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Sign On & Sign Off Actions
        </Typography>

        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
          <CircleButton variant="contained" color="secondary" onClick={handleCOCClick} sx={{ fontSize: "0.75rem" }}>
            Commencement
          </CircleButton>
          <CircleButton variant="contained" color="success" onClick={handleSignOnClick}>
            Vessel Sign On
          </CircleButton>
          <CircleButton variant="contained" color="error" onClick={handleSignOffClick}>
            Vessel Sign Off
          </CircleButton>
          <CircleButton variant="contained" color="info" onClick={handleDepartureClick}>
            Arrival
          </CircleButton>
        </Box>
      </Box>

      <hr style={{ visibility: "hidden" }} />

      {/* Full-screen loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Modals */}
      {activeModal === "coc" && (
        <COCmodal open={true} setOpen={() => setActiveModal(null)} cocDetails={cocDetails} />
      )}
      {activeModal === "signOn" && (
        <SignOnModal open={true} setOpen={() => setActiveModal(null)} signonDetails={signonDetails} />
      )}
      {activeModal === "signOff" && (
        <SignOffModal open={true} setOpen={() => setActiveModal(null)} signoffDetails={signoffDetails} />
      )}
      {activeModal === "departure" && (
        <DepartureModal open={true} setOpen={() => setActiveModal(null)} departureDetails={departureDetails} />
      )}
    </>
  );
};

export default Signinsignoffcrewingagent;
